/**
 * Length, past what the clips hold (Dax, 2026-10-04): the cut is short of what was asked by `needMs`, and
 * the person picks how to find the rest. Clips related to the ones already here are picked first.
 */
import { useState } from 'react';

export type ExtendHow = 'related' | 'next' | 'library';

const HOW: { value: ExtendHow; label: string; hint: string }[] = [
  { value: 'related', label: 'Related clips', hint: 'After each clip, the one closest to it' },
  { value: 'next', label: 'Extend each clip', hint: 'The next part of the same footage' },
  { value: 'library', label: 'New clips', hint: 'From the library, to the end' },
];

export function ExtendModal({ needMs, pending, error, onGo, onClose }: {
  needMs: number;
  pending: boolean;
  error: string | null;
  onGo: (how: ExtendHow) => void;
  onClose: () => void;
}) {
  const [how, setHow] = useState<ExtendHow>('related');
  return (
    <>
      <button type="button" className="overlay overlay-btn" aria-label="Close" onClick={onClose} />
      <div className="modal confirm-modal extend-modal" role="dialog" aria-label="Make the cut longer">
        <h2>{(needMs / 1000).toFixed(1)} s more</h2>
        <span className="sub">Every clip is already as long as it goes.</span>
        <div className="remix-options" role="radiogroup" aria-label="Where the rest comes from">
          {HOW.map((h) => (
            <label key={h.value} className={`remix-option extend-option${how === h.value ? ' on' : ''}`}>
              <span className="row extend-option-head">
                <input type="radio" name="extend-how" value={h.value} checked={how === h.value} onChange={() => setHow(h.value)} />
                <b>{h.label}</b>
              </span>
              <span className="sub">{h.hint}</span>
            </label>
          ))}
        </div>
        {error && <div className="error" role="alert">{error}</div>}
        <div className="row between">
          <button type="button" className="btn quiet" onClick={onClose}>Cancel</button>
          <button type="button" className="btn primary" disabled={pending} onClick={() => onGo(how)}>{pending ? 'Adding…' : 'Continue'}</button>
        </div>
      </div>
    </>
  );
}
